import { useI18n } from '../i18n';
import { formatDateLong } from '../lib/dates';

// Browsers show a date picker in the computer's own order (10/11/2026 could be either month), so
// every picker says the chosen date in words underneath (D102). Linked with aria-describedby.
export function DateHint({ id, value }: { id: string; value: string }) {
  const { t, lang } = useI18n();
  const text = formatDateLong(value, lang);
  return (
    <span id={id} class="caption date-hint" aria-live="polite">
      {text ? t('date.chosen', { date: text }) : t('date.pick')}
    </span>
  );
}
